export const alertModes = [
    { value: 'all', label: 'Todas' },
    { value: 'sales', label: 'Solo ventas' },
    { value: 'publications', label: 'Solo publicaciones' },
    { value: 'off', label: 'Apagadas' },
]

const validModes = new Set(alertModes.map(({ value }) => value))
export const defaultAlertPreferences = () => ({ toast: 'all', desktop: 'all' })

export const normalizeAlertPreferences = (preferences) => ({
    toast: validModes.has(preferences?.toast) ? preferences.toast : 'all',
    desktop: validModes.has(preferences?.desktop) ? preferences.desktop : 'all',
})

export const notificationAlertGroup = (notification) => {
    const topic = notification.topic?.toLowerCase() ?? ''
    if (/order|shipment|shipping|message|payment|invoice|flex/.test(topic)) return 'sales'
    if (/item|product|price|stock|catalog|promotion/.test(topic)) return 'publications'
    return 'other'
}

export const shouldShowAlert = (notification, mode) =>
    mode === 'all' || mode !== 'off' && notificationAlertGroup(notification) === mode
